export const environment = {
  production: true,
  // apiUrl:
  //   'https://vendorsgate-optimistic-baboon-xw.cfapps.eu10-004.hana.ondemand.com',
  apiUrl:
    'https://vendorsgate-noisy-hyena-so.cfapps.eu10-004.hana.ondemand.com',
};
